import React, { useEffect } from "react";
import ContainerBackgroundWrapper from "../components/Backgrounds";
import { useParams } from "react-router"
import { Apis } from "../util/Apis"
import LogoCenter from "../components/LogoCenter"
import CustomLoading from "../components/CustomLoading"
import Text from "../styledComponents/TextStyled"
import {
  StatCard, StatNumber, StatLabel, PrivacyButton, ParticipantTable,
} from './SorteoParticipants.styles';
import { MachinesLayout, MachinesStats, MachineHeader, MachineRow } from './SorteoMachines.styles';
import NoSorteos from "../components/NoSorteos"
import ParticipantTicker from "../components/ParticipantTicker";
import { getCurrencyConfig } from "../components/services";
import { maskName } from "../util/privacy";
import useHideNames from "../hooks/useHideNames";
import useGet from "../hooks/useGet";

const SorteoMachines = () => {
  const currencyConfig = getCurrencyConfig()
  const { id } = useParams()
  const [hideNames, toggleHideNames] = useHideNames()

  const { loading, data, fetchData } = useGet({
    url: Apis.SORTEOS + '/sorteos/' + id + '/participants',
    initialValue: []
  })

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData({}, { showLoading: false })
    }, 5000)

    return () => clearInterval(interval)
  }, [fetchData])

  return (
    <ContainerBackgroundWrapper>
      {!loading ?
        <>
          <LogoCenter mainview={true} />
          {data.length === 0 ?
            <NoSorteos>
              <Text textStyle='small'>Este sorteo aún no tiene participantes</Text>
            </NoSorteos>
            :
            <MachinesLayout>
              <MachinesStats>
                <StatCard aria-label="Total de participantes">
                  <StatNumber>{data.length}</StatNumber>
                  <StatLabel>PARTICIPANTES</StatLabel>
                  <PrivacyButton variant="outline"
                    aria-pressed={hideNames}
                    onClick={toggleHideNames}
                  >
                    {hideNames ? 'Mostrar nombres' : 'Ocultar nombres'}
                  </PrivacyButton>
                </StatCard>
              </MachinesStats>
              <ParticipantTable aria-label="Lista de máquinas participantes">
                <MachineHeader>
                  <span>NRO. MÁQUINA</span>
                  <span>JUGADOR</span>
                  <span>AP. PROMEDIO</span>
                </MachineHeader>
                <ParticipantTicker
                  items={data}
                  visibleRows={9}
                  getKey={item => item.sessionId}
                  renderRow={item => {
                    const name = item.customerId === null ?
                      'CLIENTE SIN TARJETA'
                      :
                      maskName(item.firstName, item.lastName1, hideNames)
                    return (
                      <MachineRow>
                        <span className="machine-number">{item.machineName}</span>
                        <span className="participant-name"><span title={name}>{name}</span></span>
                        <span className="participant-coupons">
                          {item.apProm === null ?
                            (currencyConfig.symbol + ' 0')
                            :
                            currencyConfig.symbol + ' ' + item.apProm.toFixed(2)
                          }
                        </span>
                      </MachineRow>
                    )
                  }}
                />
              </ParticipantTable>
            </MachinesLayout>
          }
        </>
        :
        <CustomLoading />
      }

    </ContainerBackgroundWrapper>
  )
}

export default SorteoMachines;
